import { createAsyncThunk, createAction } from '@reduxjs/toolkit';

import { USER_ROLES } from 'constants/common';

import * as api from 'api/methods';

import * as types from './types';

export const getStudents = createAsyncThunk<any, any>(
  types.GET_STUDENTS,
  async (params: Record<string, any>, { getState }: { getState: any }) => {
    const state = getState() as any;

    const user = state.auth.user;

    const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

    const students = isRootAdmin
      ? await api.getStudents(params)
      : await api.getSchoolStudents({ schoolId: user.schoolId, params });

    return students;
  },
);

export const getSchoolStudents = createAsyncThunk<any, any>(
  types.GET_SCHOOL_STUDENTS,
  async (data: any) => {
    const students = await api.getSchoolStudents(data);

    return students;
  },
);

export const createStudent = createAsyncThunk<any, any>(
  types.CREATE_STUDENT,
  async (data: any) => {
    const student = await api.createStudent(data);

    return student;
  },
);

export const finishImportStudents = createAsyncThunk<any, any>(
  types.FINISH_IMPORT_STUDENTS,
  async (data: any) => {
    const students = await api.finishImportStudents(data);

    return students;
  },
);

export const removeStudentById = createAction<any>(types.REMOVE_STUDENT_BY_ID);
